import React from 'react'
import styles from './index.module.css'
import { timeStringFromSecondsSinceEpoch } from '../../../utils/time_helpers'
import { IconX } from '@tabler/icons-react'

const InvalidLineItem = (props) => {

    const {
        qr_data,
        device_name,
        created_at
    } = props.scan

    return (
        <>
            <div className={styles.line}>

                <div className={styles.body}>

                    <IconX size={14} className={styles.invalidIcon}/>

                    <div className={styles.code}>
                        {qr_data}
                    </div>

                    {device_name &&
                        <div className={styles.deviceName}>
                            {device_name}
                        </div>
                    }

                    <div className={styles.time}>
                        {timeStringFromSecondsSinceEpoch(created_at)}
                    </div>

                </div>

            </div>
        </>
    )

}

export default InvalidLineItem
